<template>
  <auth-layout pageClass="login-page">
    <div class="row d-flex justify-content-center align-items-center">
      <div class="col-lg-4 col-md-6 col-sm-8">
        <form @submit.prevent="submit">
          <!-- <fade-render-transition> -->
            <card>
              <l-alert type="danger" v-show="errorMessage">
                <span>
                  <b> </b> {{ errorMessage }}
                </span>
              </l-alert>
              <div slot="header">
                <div class="text-center logo-wrapper">
                  <img :src="'/static/img/' + style + '_logo.png'" class="wamed-logo" >
                </div>
                <h3 class="card-title text-center">Anmeldung</h3>
              </div>
              <div>
                <fg-input label="Email Adresse"
                  type="email"
                  v-model="email"
                ></fg-input>

                <fg-input label="Passwort"
                  type="password"
                  v-model="password"
                ></fg-input>
              </div>
              <div class="text-center">
                <button type="submit" class="btn btn-fill btn-primary btn-round btn-wd"
                  :disabled="! canSubmit"
                >
                  Anmelden
                </button>
                <br>
                <div class="forgot">
                  <router-link to="/password/forgot" class="card-category">
                    Passwort vergessen?
                  </router-link>
                </div>
              </div>
            </card>
          <!-- </fade-render-transition> -->
        </form>
      </div>
    </div>
  </auth-layout>
</template>
<script>
import AuthLayout from './AuthLayout.vue'
import LAlert from 'src/components/Alert'

export default {
  components: {
    AuthLayout,
    LAlert
  },
  data () {
    return {
      email: '',
      password: '',
      errorMessage: '',
      style:  process.env.VUE_APP_STYLE ? process.env.VUE_APP_STYLE : 'ederit'
    }
  },
  methods: {
    submit () {
      this.errorMessage = ''

      const { email, password } = this
      this.$store.dispatch('authenticate', { email, password }).then(() => {
        this.$router.push(this.$store.state.redirectAfterLoginPath || '/')
        this.$store.state.redirectAfterLoginPath = null
      }).catch(({ response }) => {
        const key = Object.keys(response.data.errors)[0]
        this.errorMessage = response.data.errors[key][0]
      })
    }
  },
  computed: {
    canSubmit () {
      const { email, password } = this
      return email.trim() && password.trim()
    }
  }
}
</script>
<style>
  .navbar-nav .nav-item p{
    line-height: inherit;
    margin-left: 5px;
  }
</style>
